/**
 * SVG Patterns Collection
 * Berbagai macam SVG patterns untuk background menggunakan Lucide Icons
 */

export const TechPattern = ({ primaryColor, darkColor }) => (
  <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <pattern id="tech-pattern" x="0" y="0" width="80" height="80" patternUnits="userSpaceOnUse">
        <rect x="0" y="0" width="80" height="80" fill={primaryColor} opacity="0.03"/>
        <g transform="translate(20, 20)">
          <path d="M12 2L2 7L12 12L22 7L12 2Z M2 17L12 22L22 17M2 12L12 17L22 12" 
                stroke={darkColor} strokeWidth="1.5" fill="none" opacity="0.15" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
        <g transform="translate(60, 60) scale(0.8)">
          <circle cx="12" cy="12" r="10" stroke={darkColor} strokeWidth="1.5" fill="none" opacity="0.1"/>
          <path d="M12 6V12L16 14" stroke={darkColor} strokeWidth="1.5" opacity="0.1" strokeLinecap="round"/>
        </g>
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#tech-pattern)"/>
  </svg>
);

export const TrianglePattern = ({ primaryColor, darkColor }) => (
  <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <pattern id="triangle-pattern" x="0" y="0" width="80" height="80" patternUnits="userSpaceOnUse">
        <rect x="0" y="0" width="80" height="80" fill={primaryColor} opacity="0.03"/>
        <g transform="translate(15, 15) scale(0.8)">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" 
                stroke={darkColor} strokeWidth="1.5" fill="none" opacity="0.15" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
        <g transform="translate(50, 50) scale(0.7)">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" 
                fill={darkColor} opacity="0.08"/>
        </g>
        <g transform="translate(55, 20) scale(0.6)">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" 
                stroke={darkColor} strokeWidth="1.5" fill="none" opacity="0.1"/>
        </g>
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#triangle-pattern)"/>
  </svg>
);

export const CakesPattern = ({ primaryColor, darkColor }) => (
  <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <pattern id="cakes-pattern" x="0" y="0" width="60" height="60" patternUnits="userSpaceOnUse">
        <rect x="0" y="0" width="60" height="60" fill={primaryColor} opacity="0.03"/>
        <g transform="translate(8, 8) scale(0.7)">
          <path d="M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8" 
                stroke={darkColor} strokeWidth="1.5" fill="none" opacity="0.15" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M4 21h16" stroke={darkColor} strokeWidth="1.5" opacity="0.15" strokeLinecap="round"/>
          <path d="M12 3v5" stroke={darkColor} strokeWidth="1.5" opacity="0.12" strokeLinecap="round"/>
          <circle cx="12" cy="3" r="1" fill={darkColor} opacity="0.15"/>
        </g>
        <g transform="translate(38, 38) scale(0.6)">
          <path d="M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8" 
                stroke={darkColor} strokeWidth="1.5" fill="none" opacity="0.12" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M4 21h16" stroke={darkColor} strokeWidth="1.5" opacity="0.12" strokeLinecap="round"/>
        </g>
        <g transform="translate(40, 10) scale(0.5)">
          <path d="M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8" 
                fill={darkColor} opacity="0.08"/>
        </g>
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#cakes-pattern)"/>
  </svg>
);

export const DotsPattern = ({ primaryColor, darkColor }) => (
  <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <pattern id="dots-pattern" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
        <g transform="translate(14, 14) scale(0.5)">
          <circle cx="12" cy="12" r="10" stroke={darkColor} strokeWidth="1.5" fill="none" opacity="0.15"/>
          <circle cx="12" cy="12" r="1" fill={darkColor} opacity="0.2"/>
        </g>
        <circle cx="0" cy="0" r="2" fill={darkColor} opacity="0.1"/>
        <circle cx="40" cy="0" r="2" fill={darkColor} opacity="0.1"/>
        <circle cx="0" cy="40" r="2" fill={darkColor} opacity="0.1"/>
        <circle cx="40" cy="40" r="2" fill={darkColor} opacity="0.1"/>
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#dots-pattern)"/>
  </svg>
);

export const GridPattern = ({ primaryColor, darkColor }) => (
  <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <pattern id="grid-pattern" x="0" y="0" width="50" height="50" patternUnits="userSpaceOnUse">
        <path d="M0 0 L50 0 L50 50 L0 50 Z" fill="none" stroke={darkColor} strokeWidth="0.5" opacity="0.1"/>
        <path d="M0 25 L50 25 M25 0 L25 50" stroke={darkColor} strokeWidth="0.3" opacity="0.05"/>
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#grid-pattern)"/>
  </svg>
);

export const GeometricPattern = ({ primaryColor, darkColor }) => (
  <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <pattern id="geometric-pattern" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
        <rect x="0" y="0" width="100" height="100" fill={primaryColor} opacity="0.02"/>
        <g transform="translate(38, 38) scale(1.2)">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" 
                stroke={darkColor} strokeWidth="1.5" fill="none" opacity="0.12" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
        <g transform="translate(8, 8) scale(0.6)">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" 
                fill={darkColor} opacity="0.06"/>
        </g>
        <g transform="translate(78, 78) scale(0.5)">
          <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z" 
                stroke={darkColor} strokeWidth="1.5" fill="none" opacity="0.1" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#geometric-pattern)"/>
  </svg>
);

/**
 * Pattern Registry
 * Mapping pattern type ke component SVG
 */
export const patternRegistry = {
  tech: TechPattern,
  triangle: TrianglePattern,
  cakes: CakesPattern,
  dots: DotsPattern,
  grid: GridPattern,
  geometric: GeometricPattern,
};

/**
 * Get available pattern types
 * @returns {string[]} - Array of available pattern types
 */
export const getAvailablePatterns = () => Object.keys(patternRegistry);

/**
 * Check if pattern type is valid
 * @param {string} type - Pattern type to check
 * @returns {boolean} - True if pattern exists
 */
export const isValidPattern = (type) => type in patternRegistry;